/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_English_SubtitlesInputs */



/**
* | output |
* | --- |
* | "ENGLISH SUBTITLES" |
*
* @param {Ccsl_Export_Header_English_SubtitlesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_english_subtitles = /** @type {((inputs?: Ccsl_Export_Header_English_SubtitlesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_English_SubtitlesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("SOUS-TITRES ANGLAIS")
	if (locale === "de") return /** @type {LocalizedString} */ ("ENGLISCHE UNTERTITEL")
	if (locale === "it") return /** @type {LocalizedString} */ ("SOTTOTITOLI IN INGLESE")
	if (locale === "ru") return /** @type {LocalizedString} */ ("АНГЛИЙСКИЕ СУБТИТРЫ")
	if (locale === "es") return /** @type {LocalizedString} */ ("SUBTÍTULOS EN INGLÉS")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("英文字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("英語字幕")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अंग्रेजी में उपशीर्षक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("LEGENDAS EM INGLÊS")
	return /** @type {LocalizedString} */ ("ENGLISH SUBTITLES")
});